export default __webpack_public_path__ + "static/media/card-blue.61547602.svg";